<template>
  <el-form-item :label="config.sectionTitle">
    <div class="sign-block">
      <el-input placeholder="Username" v-model.trim="signData.username" clearable></el-input>
      <el-input class="input-with-button" placeholder="Password" :type="passwordInputType" v-model="signData.password" clearable></el-input>
      <el-button class="input-button" :type="togglePasswordButtonType" icon="el-icon-view" title="Show/hide password" @click="togglePasswordView"></el-button>
      <el-input class="input-with-button" placeholder="OTP" v-model.trim="signData.otp" clearable></el-input>
      <el-button class="input-button" type="primary" icon="el-icon-sold-out" title="Paste OTP" @click="pasteOtp"></el-button>
      <el-button size="medium" type="primary" icon="el-icon-edit" @click="signPdf" :disabled="!enableSignButton"
      :loading="waitingForResponse">
        {{ config.buttonCaption }}
      </el-button>
    </div>
  </el-form-item>
</template>

<script>
import axios from 'axios'

/**
 * This component handles the input of digital signature credentials and calls the endpoint ('url' prop)
 * for document signing.
 * After response, component emits the corresponding event ('signed-successfully' or 'signing-error').
 * In successfull response, component stores username and password in browser's Session Storage for iterative use.
 */
export default {
  props: ['url', 'config', 'data'],
  emits: ['signed-successfully', 'signing-error'],
  data () {
    return {
      waitingForResponse: false,
      togglePasswordButtonType: 'success',
      passwordInputType: 'password',
      signData: {
        username: '',
        password: '',
        otp: ''
      }
    }
  },
  methods: {
    signPdf () {
      this.waitingForResponse = true

      const payload = {
        userName: this.signData.username,
        password: this.signData.password,
        OTP: this.signData.otp,
        ...this.data
      }

      axios.post(this.url, payload)
        .then(response => {
          if (response.data.success) {
            sessionStorage.signUsername = this.signData.username
            sessionStorage.signPassword = this.signData.password
            this.$emit('signed-successfully', this.signData)
            this.waitingForResponse = !this.config.useAfterSuccess
          } else {
            this.$emit('signing-error', response.data)
            this.waitingForResponse = false
          }
        })
        .catch(err => {
          this.$emit('signing-error', err)
          this.waitingForResponse = false
        })
    },
    pasteOtp () {
      navigator.clipboard
        .readText()
        .then(text => (this.signData.otp = text))
    },
    togglePasswordView () {
      if (this.passwordInputType === 'password') {
        this.passwordInputType = 'text'
        this.togglePasswordButtonType = 'danger'
      } else {
        this.passwordInputType = 'password'
        this.togglePasswordButtonType = 'success'
      }
    }
  },
  computed: {
    enableSignButton () {
      return !this.waitingForResponse &&
        this.signData.username !== '' &&
        this.signData.password !== '' &&
        this.signData.otp !== ''
    }
  },
  mounted () {
    this.signData.username = sessionStorage.signUsername
    this.signData.password = sessionStorage.signPassword
  }
}
</script>

<style scoped>
.sign-block {
  width: 350px;
}

.sign-block .input-with-button {
  width: calc(100% - 44px);
}

.sign-block .input-button {
  padding-left: 0px;
  padding-right: 0px;
  width: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/DocumentSigning.vue